export default __webpack_public_path__ + "static/media/Bici da Passeggio.364475dd.jpg";